var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose, faMapPin, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { OverlayTrigger } from 'ui';
import Field from './Field.js';
import classNames from 'classnames';
import { BookerContext } from '../Booker.js';
const OriginField = ({ value, onChange, onClear, myErrors, isMobile, fetchUrl, useAlgolia }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [origins, setOrigins] = useState([]);
    const intl = useIntl();
    const { vertical, useTailwindPrefix, version, showArrows, showLabels } = useContext(BookerContext);
    const [text, setText] = useState((value === null || value === void 0 ? void 0 : value.displayText) || '');
    useEffect(() => {
        if (value && value.code !== '' && (!value.displayText || value.displayText === '')) {
            fetchOrigins(value.code).then((result) => {
                if (result.length > 0) {
                    setText(result[0].displayText);
                }
            });
        }
    }, [value]);
    function onToggle(data) {
        setIsOpen(data);
        if (data && (isMobile || origins.length > 0)) {
            if (document && document.body) {
                let orig = document.body.className;
                if (!useTailwindPrefix) {
                    if (orig.indexOf('fixed md:relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'fixed md:relative';
                    }
                }
                else {
                    if (orig.indexOf('tw-fixed md:tw-relative') < 0) {
                        document.body.className = orig + (orig ? ' ' : '') + 'tw-fixed md:tw-relative';
                    }
                }
            }
        }
        else {
            if (document && document.body) {
                if (!useTailwindPrefix) {
                    document.body.className = document.body.className.replace(/ ?fixed md:relative/, '');
                }
                else {
                    document.body.className = document.body.className.replace(/ ?tw-fixed md:tw-relative/, '');
                }
            }
        }
    }
    const fetchOrigins = (query) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${fetchUrl || process.env.NEXT_PUBLIC_AIRPORTS}?query=${query.trim()}${useAlgolia ? '&forceAlgolia=true' : ''}`, {});
            if (response.ok) {
                const data = yield response.json();
                return data.map((r) => ({ id: r.Id, code: r.Code, displayText: r.DisplayText })).slice(0, 8);
            }
            else {
                throw new Error();
            }
        }
        catch (err) {
            return [];
        }
    });
    const onInputChange = (e) => {
        setText(e.currentTarget.value);
    };
    function closeSelector() {
        onToggle(false);
        setOrigins([]);
    }
    const renderOptions = (item) => {
        const setOption = (event) => {
            event.preventDefault();
            onChange(item);
            setText(item.displayText);
            closeSelector();
        };
        return (_jsx("div", Object.assign({ onClick: setOption }, { children: _jsx("a", Object.assign({ className: classNames({
                    'block py-3 px-5 whitespace-nowrap overflow-hidden text-ellipsis hover:bg-gray-100 cursor-pointer text-base text-gray-500': !useTailwindPrefix,
                    'tw-block tw-py-3 tw-px-5 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis hover:tw-bg-gray-100 tw-cursor-pointer tw-text-base tw-text-gray-500': useTailwindPrefix,
                }) }, { children: item.displayText })) }), `origin-${item.code}`));
    };
    const onInputKeyUp = (e) => {
        if (text.trim().length >= 3 && (!value || value.displayText !== text)) {
            setTimeout(() => {
                fetchOrigins(text).then((result) => {
                    setOrigins(result);
                });
            }, 500);
        }
        else {
            setOrigins([]);
        }
    };
    const clearText = () => {
        setText('');
        onClear();
    };
    return (_jsxs(OverlayTrigger, Object.assign({ isOpen: isOpen && (isMobile || origins.length > 0), onToggle: onToggle }, { children: [_jsxs(OverlayTrigger.Trigger, Object.assign({ componentTag: "div", className: classNames({
                    'mb-5': myErrors && !useTailwindPrefix,
                    'tw-mb-5': myErrors && useTailwindPrefix,
                    'md:mb-0': myErrors && !vertical && !useTailwindPrefix,
                    'md:tw-mb-0': myErrors && !vertical && useTailwindPrefix,
                }) }, { children: [_jsxs(Field, Object.assign({}, (myErrors && { hasError: true }), { children: [_jsx("div", Object.assign({ className: classNames({
                                    'w-4 flex justify-center': !useTailwindPrefix,
                                    'tw-w-4 tw-flex tw-justify-center': useTailwindPrefix,
                                }) }, { children: _jsx(FontAwesomeIcon, { icon: faMapPin }) })), _jsxs("div", Object.assign({ className: classNames({
                                    'whitespace-nowrap w-full relative': !useTailwindPrefix,
                                    'tw-whitespace-nowrap tw-w-full tw-relative': useTailwindPrefix,
                                }) }, { children: [version === 'padded' && showLabels && !vertical && (text === null || text === void 0 ? void 0 : text.length) > 0 && (_jsx("div", Object.assign({ className: classNames({
                                            'hidden absolute md:flex inset-0 text-widget-pill-a11y/75': !useTailwindPrefix,
                                            'tw-hidden tw-absolute md:tw-flex tw-inset-0 tw-text-widget-pill-a11y/75': useTailwindPrefix,
                                        }) }, { children: _jsx("div", Object.assign({ className: classNames({
                                                'text-xs truncate': !useTailwindPrefix,
                                                'tw-text-xs tw-truncate': useTailwindPrefix,
                                            }) }, { children: intl.formatMessage({ id: 'booker.origin' }) })) }))), _jsx("input", { className: classNames({
                                            'bg-transparent z-10 relative md:placeholder:text-widget-pill-a11y/90': version === 'padded' && !vertical && !useTailwindPrefix,
                                            'tw-bg-transparent tw-z-10 tw-relative md:placeholder:tw-text-widget-pill-a11y/90': version === 'padded' && !vertical && useTailwindPrefix,
                                            'outline-none w-full text-ellipsis text-[100%]': !useTailwindPrefix,
                                            'tw-outline-none tw-w-full tw-text-ellipsis tw-text-[100%]': useTailwindPrefix,
                                        }), onChange: onInputChange, value: text, type: 'text', placeholder: intl.formatMessage({ id: 'booker.origin' }), onKeyUp: onInputKeyUp })] })), (text === null || text === void 0 ? void 0 : text.length) > 0 && (_jsx("div", Object.assign({ className: classNames({
                                    'z-10': !useTailwindPrefix,
                                    'tw-z-10': useTailwindPrefix,
                                }) }, { children: _jsx(FontAwesomeIcon, { icon: faClose, onClick: clearText }) })))] })), myErrors && (_jsx("div", Object.assign({ className: classNames(Object.assign({}, (!useTailwindPrefix
                            ? {
                                'absolute mt-1 text-sm': true,
                                'bg-transparent text-red-400 w-auto md:left-0': vertical,
                                'itm-error-bubble text-red-400 w-full max-w-[90%] md:mt-widget-pill-padding-y': !vertical,
                                'md:top-[90%]': !vertical && !showLabels,
                                'md:top-[75%]': !vertical && showLabels && version === 'padded',
                            }
                            : {
                                'tw-absolute md:tw-mt-1 tw-text-sm': true,
                                'tw-bg-transparent tw-text-red-400 tw-w-auto md:tw-left-0': vertical,
                                'itm-error-bubble tw-text-red-400 tw-w-full tw-max-w-[90%] md:tw-mt-widget-pill-padding-y': !vertical,
                                'md:tw-top-[90%]': !vertical && !showLabels,
                                'md:tw-top-[75%]': !vertical && showLabels && version === 'padded',
                            }))) }, { children: _jsx("div", Object.assign({ className: classNames({
                                'truncate w-full': !useTailwindPrefix,
                                'tw-truncate tw-w-full': useTailwindPrefix,
                            }) }, { children: myErrors.message || intl.formatMessage({ id: 'booker.errors.origin' }) })) })))] })), _jsxs(OverlayTrigger.Overlay, Object.assign({ className: classNames({
                    'md:rounded-widget-pill-overlays-border-radius': !useTailwindPrefix && !vertical && version === 'padded',
                    'md:tw-rounded-widget-pill-overlays-border-radius': !useTailwindPrefix && !vertical && version === 'padded',
                    'itm-popover-withArrow before:left-5 after:left-5 md:mt-[25px]': !useTailwindPrefix && showArrows,
                    'itm-popover-withArrow before:tw-left-5 after:tw-left-5 md:tw-mt-[25px]': useTailwindPrefix && showArrows,
                    'md:mt-0.5': !useTailwindPrefix && !showArrows,
                    'md:tw-mt-0.5': useTailwindPrefix && !showArrows,
                    'bg-white md:border border-gray-200 z-10 fixed inset-0 md:inset-auto md:shadow-lg md:absolute md:min-w-[280px]': !useTailwindPrefix,
                    'tw-bg-white md:tw-border tw-border-gray-200 tw-z-10 tw-fixed tw-inset-0 md:tw-inset-auto md:tw-shadow-lg md:tw-absolute md:tw-min-w-[280px]': useTailwindPrefix,
                    'md:max-w-full': vertical && !useTailwindPrefix,
                    'md:tw-max-w-full': vertical && useTailwindPrefix,
                }) }, { children: [_jsxs("div", Object.assign({ className: classNames({
                            'md:hidden flex justify-between items-center px-4 border-b border-gray-200 h-[50px]': !useTailwindPrefix,
                            'md:tw-hidden tw-flex tw-justify-between tw-items-center tw-px-4 tw-border-b tw-border-gray-200 tw-h-[50px]': useTailwindPrefix,
                        }) }, { children: [_jsx("div", Object.assign({ className: classNames({ 'text-3xl': !useTailwindPrefix, 'tw-text-3xl': useTailwindPrefix }) }, { children: intl.formatMessage({ id: 'booker.origin' }) })), _jsx("a", Object.assign({ onClick: closeSelector, className: classNames({
                                    'cursor-pointer text-2xl': !useTailwindPrefix,
                                    'tw-cursor-pointer tw-text-2xl': useTailwindPrefix,
                                }) }, { children: _jsx(FontAwesomeIcon, { icon: faTimes }) }))] })), _jsx("div", Object.assign({ className: classNames({ 'p-4 md:hidden': !useTailwindPrefix, 'tw-p-4 md:tw-hidden': useTailwindPrefix }) }, { children: _jsxs("div", Object.assign({ className: classNames({
                                'border rounded w-full px-2 flex items-center space-x-2': !useTailwindPrefix,
                                'tw-border tw-rounded tw-w-full tw-px-2 tw-flex tw-items-center tw-space-x-2': useTailwindPrefix,
                            }) }, { children: [_jsx("input", { className: classNames({
                                        'py-2 outline-none w-full': !useTailwindPrefix,
                                        'tw-py-2 tw-outline-none tw-w-full': useTailwindPrefix,
                                    }), onChange: onInputChange, value: text, type: 'text', placeholder: intl.formatMessage({ id: 'booker.origin' }), onKeyUp: onInputKeyUp }), (text === null || text === void 0 ? void 0 : text.length) > 0 && _jsx(FontAwesomeIcon, { icon: faTimes, onClick: clearText, color: "#82888a" })] })) })), _jsx("div", Object.assign({ className: classNames({
                            'md:rounded-widget-pill-overlays-border-radius-inner md:overflow-auto': !useTailwindPrefix && !vertical && version === 'padded',
                            'md:tw-rounded-widget-pill-overlays-border-radius-inner md:tw-overflow-auto': useTailwindPrefix && !vertical && version === 'padded',
                        }) }, { children: origins.length > 0 && origins.map(renderOptions) }))] }))] })));
};
export default OriginField;
